(() => {
  if (window.__giestoArketProduct) return;
  window.__giestoArketProduct = true;
  const identity = p => String(p.id || '').replace('gid://shopify/Product/', '');
  function renderColors(container, source) {
    const group = window.GiestoColorGroups.match(container, source);
    const root = container.closest('giesto-store-product');
    const current = group.products.find(p => identity(p) === container.dataset.p);
    const trigger = root?.querySelector('[data-gap-colour-groups-trigger]');
    if (!current || !trigger) return;
    const singleColor = root.querySelector('[data-gaa-single-color]');
    if (singleColor && current.colorCode) singleColor.firstElementChild.style.background = current.colorCode;
    trigger.hidden = group.products.length < 2;
    trigger.querySelector('.gap__colour-label').textContent = `${current.color || container.dataset.productColor || ''}${group.products.length > 1 ? ' +' + (group.products.length - 1) : ''}`;
    trigger.querySelector('.gap__colour-swatch').style.backgroundColor = current.colorCode || '#888';
    const grid = document.createElement('div');grid.className = 'ga-product-colors';
    for (const product of group.products) {
      const link = document.createElement('a');link.href = `${(container.dataset.root || '/').replace(/\/$/, '')}/products/${product.handle}`;
      const selected = identity(product) === container.dataset.p;
      if (selected) link.setAttribute('aria-current', 'true');
      const src = product.image || product.featuredImage?.url;
      if (src) {const img = document.createElement('img');img.src = src;img.alt = product.color || '';img.loading = 'lazy';link.append(img);}
      const label = document.createElement('span');label.textContent = product.color || product.title;link.append(label);
      if (product.availableForSale === false) link.classList.add('is-sold-out');
      grid.append(link);
    }
    container.replaceChildren(grid);
  }
  function scan() {
    const pc = window.CSGA?.PC;
    if (!pc?.render || !window.GiestoColorGroups) return false;
    if (!pc.__giestoProduct) {
      const original = pc.render;
      pc.render = function(container, group) {
        if (container.closest('[data-gap-colour-groups]')) return renderColors(container, group);
        return original.call(this, container, group);
      };
      pc.__giestoProduct = true;
    }
    document.querySelectorAll('[data-gap-colour-groups] .csga-pc').forEach(e => { e.replaceChildren(); delete e.dataset.loaded; });
    pc.scan();return true;
  }
  if (!scan()) {
    const app = document.createElement('script');app.src = '/apps/renk-grubu/pc.js?v=2';app.async = true;app.addEventListener('load', scan, {once:true});document.head.append(app);
  }
  // Use the existing gallery images in an accessible full-screen viewer.
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-gap-zoom]');if (!trigger) return;
    const product = trigger.closest('giesto-store-product');
    const images = [...product.querySelectorAll('[data-gap-zoom] img')];
    const index = images.indexOf(trigger.querySelector('img'));
    let dialog = product.querySelector('.ga-product-zoom');
    if (!dialog) {
      dialog = document.createElement('dialog');dialog.className = 'ga-product-zoom';dialog.setAttribute('aria-label', trigger.getAttribute('aria-label'));
      const close = document.createElement('button');close.type = 'button';close.className = 'ga-product-zoom__close';close.setAttribute('aria-label', document.documentElement.lang === 'tr' ? 'Kapat' : 'Close');close.textContent = '×';close.onclick = () => dialog.close();
      const track = document.createElement('div');track.className = 'ga-product-zoom__track';
      for (const image of images) { const large = image.cloneNode();large.removeAttribute('sizes');large.removeAttribute('srcset');large.loading = 'lazy';large.alt = image.alt;track.append(large);}
      dialog.append(close, track);product.append(dialog);
      dialog.addEventListener('close', () => trigger.focus({preventScroll:true}));
    }
    dialog.showModal();
    const track = dialog.querySelector('.ga-product-zoom__track');
    requestAnimationFrame(() => {track.scrollLeft = index * track.clientWidth;});
  });
})();
